<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="isPending" />
    <CheckboxInput v-else :options="languageOptions" :model="languagesModel" />
  </div>
  <div class="offcanvas-footer">
    <FormButton
      :marginVertical="false"
      label="Concluir"
      :loading="submitting"
      @onClick="submit"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { languagesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import LanguagesObj from "@/utils/LanguagesObj";
import { useLanguages } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { languages: allLanguages, isPending } = useLanguages();

const { handleSubmit, resetForm } = useForm({
  validationSchema: toTypedSchema(languagesSchema),
  initialValues: { languages: [] },
});

const languagesModel = useVeeField<number[]>("languages");

onMounted(() => {
  resetForm({
    values: {
      languages: session.value?.languages.map((l: any) => l.language_id) ?? [],
    },
  });
});

const languageOptions = computed(() =>
  allLanguages.value.map((l) => ({
    ...l,
    name: `${(LanguagesObj as any)[l.code]?.flag ?? ""} ${l.name}`.trim(),
    selected: languagesModel.$model.includes(l.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, languages: values.languages });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
